// extracted by mini-css-extract-plugin
export var banner = "index-module--banner--KIvhz";
export var text = "index-module--text--5nxt6";
export var text_mobile = "index-module--text_mobile--3yrqj";